import { shareColumnsExtend, shareFormColumnsExtend } from './share';

const entityColumns = {
  id: {
    model_name: 'WithdrawalApplication',
    column_type: 'id',
  },
  created_at: {
    model_name: 'WithdrawalApplication',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'WithdrawalApplication',
    column_type: 'datetime',
  },
  amount_cents: {
    model_name: 'WithdrawalApplication',
    column_type: 'integer',
  },
  channel: {
    model_name: 'WithdrawalApplication',
    column_type: 'string',
  },
  number: {
    model_name: 'WithdrawalApplication',
    column_type: 'string',
  },
  receivable_account_type: {
    model_name: 'WithdrawalApplication',
    column_type: 'string',
  },
  auditor: {
    model_name: 'WithdrawalApplication',
    column_type: 'belongs_to',
    extra: {
      association_name: 'auditor',
      model_name: 'AdminUser',
      foreign_key: 'auditor_id',
    },
  },
  auditor_id: {
    model_name: 'WithdrawalApplication',
    column_type: 'belongs_to',
    extra: {
      association_name: 'auditor',
      model_name: 'AdminUser',
      foreign_key: 'auditor_id',
    },
  },
  state: {
    model_name: 'WithdrawalApplication',
    column_type: 'enum',
  },
  wallet_holder: {
    model_name: 'WithdrawalApplication',
    column_type: 'belongs_to',
    extra: {
      association_name: 'wallet_holder',
      model_name: 'Miapay::WalletHolder',
      foreign_key: 'wallet_holder_id',
    },
  },
  wallet_holder_id: {
    model_name: 'WithdrawalApplication',
    column_type: 'belongs_to',
    extra: {
      association_name: 'wallet_holder',
      model_name: 'Miapay::WalletHolder',
      foreign_key: 'wallet_holder_id',
    },
  },
  finished_at: {
    model_name: 'WithdrawalApplication',
    column_type: 'datetime',
  },
  reject_reason: {
    model_name: 'WithdrawalApplication',
    column_type: 'text',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(entityColumns, columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(entityColumns, columns, { formColumnsConfig, type, data })
}
